<script setup lang="ts">
import GenericError from '~/components/user-interface/generic-error.vue';
import Tab from '~/components/design-system/tabs/tab.vue';
import GenericLoader from '~/components/user-interface/generic-loader.vue';
import type { TStandardImageKeys } from 'assets/data/branding-library';
import type { TWinnersCategory } from '~/interfaces/winners/winnersInterfaces';
defineProps<{ tab: TWinnersCategory }>();
</script>
<template>
  <div class="px-2 bg-white dark:bg-dark-800 w-full rounded-lg">
    <div class="flex flex-col justify-between items-center">
      <WinnersSectionHeader
        :title="tab.key"
        :alt="$t(tab.key)"
        :icon-name="tab.icon as TStandardImageKeys"
      />
    </div>
    <div v-if="!!tab.data">
      <div>
        <WinnersCategoryList
          v-if="!!tab.data && tab.data?.length > 0"
          :games="tab.data"
          :category="$t(tab.key)"
        />
        <GenericError v-else :scroll-to-view="false">
          {{ $t(`${tab.key}-list-empty`) }}
        </GenericError>
      </div>
    </div>
    <GenericLoader v-else :standalone="true" />
  </div>
</template>
